/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import { createTagList } from '../../utils/utils';
export const LiveStream = (data, isAws) => {
  const sponsor = isAws
    ? data.sponsordetailinfo_s && data.sponsordetailinfo_s[0]
    : data.sponsordetailinfo_s && JSON.parse(data.sponsordetailinfo_s)[0];
  return {
    fields: {
      //   PostLiveHeading: {
      //     value: 'Live broadcast has ended.',
      //   },
      //   PreLiveHeading: {
      //     value: 'Live broadcast starting soon.',
      //   },
      //   LiveVideoID: {
      //     value: '6147940392001',
      //   },
      //   PostLiveDescription: {
      //     value: 'Sorry, you missed this live programme.',
      //   },
      //   PreLiveDescription: {
      //     value: 'This programme has not started yet – live video will be available shortly',
      //   },
      ThumbnailImage: {
        value: {
          Crops: isAws
            ? data.celumimagesvariant_s &&
              data.celumimagesvariant_s.ImageCropUrl &&
              data.celumimagesvariant_s.ImageCropUrl.CropUrl
              ? data.celumimagesvariant_s.ImageCropUrl.CropUrl
              : data.imagecropurl_s
            : data.imagecropurl_s && JSON.parse(data.imagecropurl_s),
          isWebpAvailable: isAws
            ? data.celumimagesvariant_s &&
              data.celumimagesvariant_s.ImageCropUrl &&
              data.celumimagesvariant_s.ImageCropUrl.isWebpAvailable
            : data.iswebpavailablebool_b,
        },
      },
      VideoFile: {
        value: {
          MediaId: data.mediaid_s,
          Orientation: data.celummetadatadetails_s && data.celummetadatadetails_s.dimension,
        },
      },
      AuthorName: isAws ? data.authorname_s : data.author_t,
      Teaser: {
        value: data.teaser_t,
      },
      ShortHeadline: {
        value: data.shortheadline_t,
      },
      Variant: {
        value: data.variant_t && data.variant_t.toLowerCase(),
      },
      IsLoginRequire: {
        value: data.isloginrequire_b,
      },
      ContentType: {
        value: data.contenttype_t,
      },
      CardType: {
        value: data.cardtype_t,
      },
      ContentAccess: {
        value: data.contentaccess_t ? data.contentaccess_t : null,
      },
      Sponsorby: sponsor
        ? {
            fields: {
              PartnerIconDark: {
                value: {
                  Crops: {
                    img1x: sponsor.PartnerIconDark,
                  },
                },
              },
              PartnerName: {
                value: sponsor.PartnerName,
              },

              CTAURL: {
                value: {
                  href: sponsor.CTAURL,
                },
              },

              MCC_MNC: {
                value: sponsor.MCC_MNC,
              },
              PartnerIconLight: {
                value: {
                  Crops: {
                    img1x: sponsor.PartnerIconLight,
                  },
                },
              },
              PartnerText: {
                value: sponsor.PartnerText,
              },
            },
          }
        : null,
      __Published: {
        value: data.appearance_tdt || data.__published_tdt,
      },
      __PublishedBy: {
        value: data.__publishedby_t,
      },
      manutds: {
        value: {
          DestinationUrl: data.destinationurl_s,
          Author: isAws ? data.authorname_s : data.author_t,
          Tags: createTagList(data.taglist_sm, data.category_s),
        },
      },
    },
    rendering: {
      dataSource: data.itemid_s,
    },
  };
};
